import { createSlice } from "@reduxjs/toolkit";
import type { ISearchPageState } from "@litres-libs/types";
import { addHydrateReducer } from "../../utils/hydrateReducer";
import { searchApi } from "../../rtkq/search/search.api";

const initialState: ISearchPageState = {
  query: "",
};

export const searchPageSlice = createSlice({
  name: "global/searchPage",
  initialState,
  reducers: {},
  extraReducers: builder => {
    addHydrateReducer(builder, "global.searchPage");

    builder.addMatcher(
      searchApi.endpoints.getSearchData.matchPending,
      (state: ISearchPageState, action) => {
        state.query = action.meta.arg.originalArgs.q;
      }
    );

    builder.addMatcher(
      searchApi.endpoints.getSearchData.matchFulfilled,
      (state: ISearchPageState, { payload }) => {
        if (payload) {
          state.appliedCorrection = payload.extra.applied_correction;
        }
      }
    );
  },
});

export default searchPageSlice.reducer;
